import { render, staticRenderFns } from "./selectComponentsFromWarehouse.vue?vue&type=template&id=2860743a"
import script from "./selectComponentsFromWarehouse.vue?vue&type=script&lang=js"
export * from "./selectComponentsFromWarehouse.vue?vue&type=script&lang=js"
import style0 from "./selectComponentsFromWarehouse.vue?vue&type=style&index=0&id=2860743a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports